import React from "react";
import { useTranslation } from "react-i18next";
import { FileText } from "lucide-react";
import { BRAND } from "../config";

const CONTACT = "restaurantejobs.official@gmail.com";
const UPDATED = "12/07/2026";

const ES = [
  ["1. Aceptación", `Al usar RestauranteJobs (${BRAND.domain}) y nuestras apps, aceptas estos Términos y Condiciones. Si no estás de acuerdo, no uses el servicio.`],
  ["2. El servicio", "RestauranteJobs conecta candidatos con restaurantes en Estados Unidos. Los candidatos pueden buscar y postularse a vacantes gratis; los empleadores publican vacantes y contratan planes de suscripción."],
  ["3. Cuentas", "Eres responsable de la veracidad de tus datos y de mantener segura tu contraseña. Puedes editar o eliminar tu cuenta en cualquier momento desde 'Ajustes de cuenta'."],
  ["4. Planes y pagos", "Los empleadores pueden contratar planes de pago procesados por Stripe. Al activar la renovación automática, autorizas cobros mensuales hasta que canceles. Los precios se muestran antes de pagar."],
  ["5. Conducta", "No se permite contenido falso, ilegal, discriminatorio ni ofertas de empleo fraudulentas. Podemos suspender cuentas que incumplan estas reglas."],
  ["6. Contenido de terceros", "Podemos mostrar anuncios de terceros (p. ej. Google AdSense). No somos responsables del contenido de anunciantes externos."],
  ["7. Limitación de responsabilidad", "RestauranteJobs es un intermediario; no garantizamos contrataciones ni la conducta de empleadores o candidatos. El servicio se ofrece 'tal cual'."],
  ["8. Cambios", "Podemos modificar estos términos. Publicaremos la fecha de la última actualización en esta página."],
  ["9. Contacto", `Para dudas sobre estos términos, escríbenos a ${CONTACT}.`],
];

const EN = [
  ["1. Acceptance", `By using RestauranteJobs (${BRAND.domain}) and our apps, you accept these Terms & Conditions. If you disagree, do not use the service.`],
  ["2. The service", "RestauranteJobs connects candidates with restaurants in the USA. Candidates can search and apply to jobs for free; employers post jobs and subscribe to paid plans."],
  ["3. Accounts", "You are responsible for the accuracy of your data and keeping your password safe. You can edit or delete your account at any time from 'Account settings'."],
  ["4. Plans & payments", "Employers may purchase paid plans processed by Stripe. By enabling auto-renewal, you authorize monthly charges until you cancel. Prices are shown before payment."],
  ["5. Conduct", "False, illegal, discriminatory content or fraudulent job offers are not allowed. We may suspend accounts that break these rules."],
  ["6. Third-party content", "We may display third-party ads (e.g. Google AdSense). We are not responsible for external advertiser content."],
  ["7. Limitation of liability", "RestauranteJobs is an intermediary; we do not guarantee hires or the conduct of employers or candidates. The service is provided 'as is'."],
  ["8. Changes", "We may update these terms. We will post the last-updated date on this page."],
  ["9. Contact", `For questions about these terms, email us at ${CONTACT}.`],
];

export default function Terms() {
  const { i18n } = useTranslation();
  const en = i18n.language?.startsWith("en");
  const sections = en ? EN : ES;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="terms-page">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-11 h-11 rounded-xl bg-brand-soft flex items-center justify-center"><FileText className="w-6 h-6 text-brand" /></div>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-stone-text">{en ? "Terms & Conditions" : "Términos y Condiciones"}</h1>
      </div>
      <p className="text-sm text-stone-muted mb-8">{en ? "Last updated" : "Última actualización"}: {UPDATED}</p>
      <div className="space-y-7">
        {sections.map(([title, body], i) => (
          <section key={i}>
            <h2 className="font-heading text-lg font-bold text-stone-text mb-1">{title}</h2>
            <p className="text-stone-sub leading-relaxed text-sm sm:text-base">{body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
